import React from "react"
// import { Tooltip as TooltipAnt } from "antd"
import { Tooltip, TooltipContent, Tooltip as TooltipShad, TooltipTrigger } from "components/ui/Tooltip"
import { cn } from "lib/utils"

interface TooltipProps {
  disabled?: boolean
  children: React.ReactNode
  title?: string | React.ReactNode
  side?: "top" | "bottom" | "left" | "right"
  className?: string
  mouseEnterDelay?: number
  color?: string
  sideOffset?: number
}

function TooltipWrap(props: TooltipProps) {
  if (props.disabled || !props.title) {
    return <>{props.children}</>
  }

  return (
    <Tooltip delayDuration={props.mouseEnterDelay !== undefined ? props.mouseEnterDelay * 1000 : 400}>
      <TooltipTrigger asChild>{props.children}</TooltipTrigger>
      <TooltipContent className={cn(props.className)} side={props.side} color={props.color} sideOffset={props.sideOffset}>
        <div className="max-w-xs text-wrap">{props.title}</div>
      </TooltipContent>
    </Tooltip>
  )
  // return (
  //   <TooltipAnt
  //     // placement="top"
  //     mouseEnterDelay={0.2}
  //     mouseLeaveDelay={0}
  //     destroyTooltipOnHide
  //     autoAdjustOverflow
  //     zIndex={9999}
  //     {...props}
  //   >
  //     <div>{props.children}</div>
  //   </TooltipAnt>
  // )
}

export default TooltipWrap
